import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from '../../prototypes/generic.view.ts';

import Handlebars from 'handlebars';
import HandlebarsHelpers from 'handlebarsHelpers';

import Template from 'text-loader!../templates/register.template.hbs';

import i18n from "l10n";


export default GenericView.extend({
    el: "#main",
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: async function (options) {
		var self = this;

		this.render();

		this.fields =
			{
				email: [this.isEmpty, this.isEmail],
				password: [this.isEmpty, this.minLengthNumber, this.maxLengthNumber, this.isNoValidPassword],
				repeatPassword: [this.isEmpty, this.sameValues],
                acceptTerms: [this.isNotChecked]
			};
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		this.$el.html(this.template());

		return this;
	},
	events:{
		"click #registerButton": "submitRegistration",
		"change .to-validation": "validateIt",
		"keyup .to-validation": "validateIt",
		"click .togglePasswordType": "togglePassWordViewable",
		"click .togglePasswordTypeRepeat": "togglePassWordViewable",
		"click #facebook": "facebookAuth",
		"click #google": "googleAuth"
	},

	validateIt: function(event)
	{
		var element = $(event.currentTarget);
		var field = {};
		field[element.prop("id")] = this.fields[element.prop("id")]

		//console.info(field);
		this.validateFields( field );
	},

	submitRegistration: async function (e) {
	    e.preventDefault();
		var fields = $.extend({}, this.fields);

		var has_error_fields = this.validateFields(fields)

        var data = {};
        var personalInfo = {};
		data.password = $("#password").val();
		data.email = $("#email").val();
		personalInfo.firstName = $("#name").val() != "" ? $("#name").val()  : null ;
		personalInfo.lastName = $("#surname").val() != "" ? $("#surname").val()  : null;
		personalInfo.phoneNumber = $("#phone").val() != "" ? $("#phone").val() : null;
		data.personalInfo = personalInfo;

		var $elem = this.$el.find("#registerButton");

		if(has_error_fields) {
			$.notify(
				i18n.t('store.invalidInputs'),
				{ position:"top center", className: "error" }
			);
			return;
		}

		$.ajaxDefaultQ({
			url: window.ip+`/rest/auth/users`,
			type: 'POST',
			data: JSON.stringify(data),
            contentType : 'application/json'
		}).done(function (response, status, xhr) {

			if (response && response.error != null) {
				if (response.error.message == "EMAIL_SEND_FAIL") {
					$.notify(
						i18n.t('error.email_send_fail'),
						{ position:"top center", className: "error" }
					);
				}
			}
			else
			{
				$elem.notify(
					i18n.t("store.register.checkmail"),
					{position: "bottom center", className: "success"}
				);
			}

			setTimeout(() => {
				window.open('store.html', '_self');
			}, 5000);
		}).fail(function (error) {
			var errorMsg = "";
			var statusCode = error.status;
			var systemErrorCode = error.responseJSON && error.responseJSON.error && error.responseJSON.error.exception && error.responseJSON.error.exception.code ? error.responseJSON.error.exception.code : -1;
			var errorMessage = error.responseJSON.error.message;
			var errorCode = error.responseJSON.error.code;

			if (errorCode == 103)
				errorMsg = i18n.t("store.register.weakPassword");
			else if (errorCode == 102)
				errorMsg = i18n.t("account.invalid_email");
			else if (errorCode == 112 || errorMessage == "Username already exists")
				errorMsg = i18n.t("store.register.usernameexists");
			else if (errorCode == 101 || errorMessage == "Email already exists")
				errorMsg = i18n.t("store.register.emailexists");
			else if (statusCode == 502)
				errorMsg = i18n.t("server.is_down");
			else
				errorMsg = i18n.t("store.register.errorRegister");

			$elem.notify(errorMsg, {position: "bottom center", className: "error"});
		});
	},
	togglePassWordViewable: function (event) {
		this.togglePassWordViewableGeneric(event);
	},
	facebookAuth: function () {
		this.facebookAuthOpenDialog();
	},
	googleAuth: function () {
		this.googleAuthOpenDialog();
	}
});
